/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-01 15:29:28
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-27 15:58:13
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductCustomization/index.tsx
 */
import React from 'react';

import css from './css.module.less';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { dispatch } from 'src/store';

import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/BasicPageHOC';
import { NULL } from 'src/tools/constant';
import RouteBlock from './RouteBlock';

import Warning from '@/src/components/Antd/Modal/WarningModal';
import QuestionIconTooltip, {
  EnumPosition,
} from 'src/components/QuestionIconTooltip';
import { PreviewWrapper } from 'src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';
import NonPrimaryTip from 'src/pages/SalesChannelContentEditor/Components/DisabledSectionTip';
import { DEFAULT_MULTI_LANGUAGE_PARAMS } from '@/src/types/server/params';
import {
  deleteProduct,
  displayProduct,
  hideProduct,
} from 'src/pages/SalesChannelProductsConfig/slice/reduxCommonFunctions';
import TranslationTip from 'src/constrains/SalesChannelAITranslation/TranslationTip';
import PageWrapper from '../../../constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper2';
import RightConfigWrapper from '../../../constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';
import CloneBtn from './CloneButton';
import CustomisationButton from './CustomisationButton';
import EnableConfig from './EnableConfig';
import MockupImage from './MockupImage';
import Preview from './Preview';
import Service from './Service';
import {
  fetchCustomization,
  getHasModified,
  getPageEnabled,
  getSalesChannelName,
  getSalesChannelProduct,
  getState,
  getTranslationState,
  //submitContentHomepage,  submitContentShoppingCart,
  //submitContentShoppingCart,
  resetData,
  submitCustomization,
  validation,
  translateProductCustomization,
} from './slice';
import { convertDataFromReduxToServer } from './tools';

import { useI18n } from 'src/hooks/useRouterChange';
import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from 'src/tools/getUserInfo';
import { i18nGet } from 'src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';

const permissions = (saleChannelUuid) => {
  const canViewDetails = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.view_product_details_page,
      }),
    ],
  });
  const canCreate = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.add_edit_product,
      }),
    ],
  });
  const canDelete = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.delete_product,
      }),
    ],
  });
  return { canViewDetails, canCreate, canDelete };
};

const SalesChannelProductCustomization = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [noProductWarning, setNoProductWarning] = React.useState(false);
  const _d = useDispatch();
  const _h = useHistory();
  const {
    onDiscard,
    onGoBack,
    submitData,
    hasModified,
    salesChannel: salesChannelProduct,
    salesChannelName,
    isOnPrimaryLanguage,
  } = props;
  const { productName, visible } = salesChannelProduct || {};
  const _enable = useSelector(getPageEnabled());
  const {
    translationEnabled,
    salesChannelProductCustomisationUuid,
    translationLoading,
  } = useSelector(getTranslationState());
  console.log('translationEnabled', translationEnabled);

  const _params: {
    salesChannelProductUuid: string;
    saleChannelUuid: string;
  } = useParams();
  const multiLanguageParams = DEFAULT_MULTI_LANGUAGE_PARAMS;
  const { salesChannelProductUuid, saleChannelUuid } = _params;

  const onDelete = () => {
    _d(deleteProduct(salesChannelProductUuid));
  };

  const onChangeVisibility = (e) => {
    if (e !== visible) {
      if (e) {
        _d(displayProduct(salesChannelProductUuid));
      } else {
        _d(hideProduct(salesChannelProductUuid));
      }
    }
  };
  const handleOnTranslate = (translationEnabled) => {
    _d(
      translateProductCustomization({
        uuid: salesChannelProductCustomisationUuid,
        translationEnabled,
        multiLanguageParams,
      }),
    );
  };
  const { canViewDetails, canCreate, canDelete } = permissions(saleChannelUuid);
  const hideEdit = !canCreate;

  React.useEffect(() => {
    if (salesChannelProductUuid === NULL) {
      setNoProductWarning(true);
    } else {
      // _d(
      //   fetchCustomization({
      //     productUuid: salesChannelProductUuid,
      //   }),
      // );
    }

    return () => {
      _d(resetData());
    };
  }, []);

  return (
    <React.Fragment>
      {/* <button
        onClick={() => {
          _h.push(`/salesChannel/products/link/${saleChannelUuid}/${NULL}`);
        }}>
        123
      </button> */}
      <Warning
        visible={noProductWarning}
        header={getI18n(
          'salesChannelProductCustomization.index.setupproductfirst',
        )}
        cancelText={getI18n(
          'salesChannelProductCustomization.index.gotosettings',
        )}
        afterClose={() => {
          _h.push(`/salesChannel/products/link/${saleChannelUuid}/${NULL}`);
        }}
        onCancel={() => {
          setNoProductWarning(false);
        }}>
        {getI18n('salesChannelProductCustomization.index.setupproductfirst')}
      </Warning>
      <RouteBlock hasModified={hasModified} />

      <PageWrapper
        avoidSubmitWhenHasError
        headerConfig={{
          hasModified,
          submit: canCreate && submitData,
          description: canViewDetails && productName,
          topTitle: salesChannelName,
          onDiscard,
          onGoBack,
          onDelete: canDelete && onDelete,
          visible,
          onChangeVisibility: canCreate && onChangeVisibility,
          translationEnabled,
          handleOnTranslate,
          translationLoading,
        }}
        leftChild={
          canViewDetails ? (
            <PreviewWrapper>
              <div className={css.translationTip}>
                {' '}
                {translationEnabled && !isOnPrimaryLanguage && (
                  <TranslationTip />
                )}
              </div>
              <Preview translationEnabled={translationEnabled} />
            </PreviewWrapper>
          ) : (
            <div className={css.content}>
              {getI18n('general.permission.permissiondenied')}
            </div>
          )
        }
        rightChild={
          canViewDetails ? (
            <RightConfigWrapper
              title={
                <div className={css.title}>
                  {getI18n('general.sider.customisation')}
                  <QuestionIconTooltip
                    title={getI18n('general.sider.customisation')}
                    content={getI18n(
                      'salesChannelProductCustomization.index.questionIconTooltipcontent',
                    )}
                    placement={EnumPosition.bottom}
                  />
                </div>
              }
              elements={[
                {
                  body: (
                    <Comp
                      enabled={_enable}
                      isPrimary={isOnPrimaryLanguage}
                      disabled={!canCreate || translationEnabled}
                      hideEdit={hideEdit}
                    />
                  ),
                  key: 'TopConfig',
                },
              ]}
            />
          ) : null
        }
      />
    </React.Fragment>
  );
};
export default BasicPageHOC(SalesChannelProductCustomization, {
  getState,
  convertDataFromReduxToServer,
  submit: submitCustomization,
  getHasModified,
  getSalesChannel: getSalesChannelProduct,
  getSalesChannelName,
  validation,
  baseURL: '/salesChannel/products/',
  queryData: (params, qParams) => {
    const { salesChannelProductUuid } = params;
    if (salesChannelProductUuid !== NULL) {
      dispatch(
        fetchCustomization({
          productUuid: salesChannelProductUuid,
          params: qParams,
        }),
      );
      // dispatch(
      //   fetchTcs({
      //     uuid: saleChannelUuid,
      //   }),
      // );
    }
  },
});
const Comp = ({ enabled, isPrimary, disabled, hideEdit }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const Components = React.useMemo(() => {
    if (isPrimary) {
      if (enabled) {
        return (
          <React.Fragment>
            <EnableConfig disabled={disabled} />
            <MockupImage isPrimary={isPrimary} disabled={disabled} />
            <Service disabled={disabled} />
            <CustomisationButton disabled={disabled} />
          </React.Fragment>
        );
      }
      return <EnableConfig disabled={disabled} />;
    } else {
      if (enabled) {
        return (
          <React.Fragment>
            <CloneBtn disabled={disabled} />
            <MockupImage
              isPrimary={isPrimary}
              disabled={disabled}
              hideEdit={hideEdit}
            />
            <CustomisationButton isPrimary={isPrimary} disabled={disabled} />
          </React.Fragment>
        );
      }
      return (
        <div className={css.nonPrimaryTip}>
          <NonPrimaryTip
            tip={getI18n(
              'salesChannelProductCustomization.index.nonPrimaryTipContent',
            )}
          />
        </div>
      );
    }
  }, [disabled, enabled, isPrimary]);
  return <React.Fragment>{Components}</React.Fragment>;
};
